module.exports = __webpack_public_path__ + "img/image.f2e8638f.jpg";